<template>
    <div class="card">
        <Toast />
        <form>
            <div class="p-grid p-fluid">
                <div class="p-col-12">
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-6 p-mb-lg-0 p-field d-flex">
                            <label for="title2" id="switch"
                                ><b>{{ $t('Free1.list.Active') }}</b></label
                            >
                            <!-- <InputSwitch v-model="status" trueValue="active" @change="switchValue(id, status)" /> -->
                            <InputSwitch v-model="details.status" trueValue="active" />
                        </div>
                    </div>
                    <h5>
                        <b>{{ $t('Free1.form.Heading') }}</b>
                    </h5>

                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-12 p-mb-lg-0 p-field">
                            <label for="title2"
                                ><b>{{ $t('Free1.form.FirstInfo') }}</b></label
                            >
                            <Textarea :class="`${error.description ? 'p-invalid' : ''}`" type="text" :placeholder="$t('Free1.form.Desc')" id="desc1" v-model="details.description"></Textarea>
                            <div class="text-red">{{ error.description }}</div>
                        </div>
                    </div>
                    <h5>
                        <b>{{ $t('Free1.form.Productinformationmodal') }}</b>
                    </h5>

                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-7 p-mb-lg-0 p-field">
                            <label for="subtitle2">
                                <b>{{ $t('Free1.form.Pic') }}</b>
                                <!-- <span class="img-info">(File Type jpg,jpeg,png )</span> -->
                            </label>
                            <div :class="`${error.file ? 'custom-select-invalid' : 'custom-select'}`">
                                <span v-if="!fileName">{{ $t('Free1.form.Selectfile') }}</span>
                                <span v-else>{{ fileName }}</span>
                                <input type="file" class="select-file" v-on:change="onFileChange" />
                                <Button :label="$t('Free1.form.select_file')" class="SelectBtn n-wrap" />
                            </div>
                            <label for="subtitle2">{{ $t('Free1.list.File') }}</label
                            ><br />
                            <!-- <div class="text-red">{{ error.file }}</div> -->
                            <div class="text-red" v-show="render1">{{ $t('validation.invalidFile') }}</div>
                            <div class="text-red" v-show="render2">파일이 너무 큽니다</div>
                            <Image :src="modal_image" alt="이미지를 사용할 수 없음" class="product-image" width="137" height="85" preview />
                        </div>
                    </div>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-12 p-mb-lg-0 p-field" id="desc1">
                            <label for="title2"
                                ><b>{{ $t('Free1.form.ModalInfo') }}</b></label
                            >
                            <Textarea :class="`${error.modal_info ? 'p-invalid' : ''}`" type="text" :placeholder="$t('Free1.form.Desc')" id="desc1" v-model="details.modal_info"></Textarea>
                            <div class="text-red">{{ error.modal_info }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-d-flex p-jc-end p-ai-center" style="float: left">
                <ConfirmPopup group="popup"></ConfirmPopup>
                <Button :label="$t('Admin.AddAdmin.Save')" icon="pi pi-check" iconPos="left" class="p-button p-button p-mr-2 p-mb-2" @click="confirm($event)" style="margin-top: -20px; background: black; color: white"></Button>
            </div>
        </form>
    </div>
    <div class="p-grid">
        <Toast />

        <div class="p-col-12">
            <div class="card p-fluid">
                <h4>
                    <strong>{{ $t('Admin.list.Search') }}</strong>
                </h4>
                <div class="p-formgrid p-grid p-mb-3">
                    <div class="p-field p-col-12 p-md-3">
                        <label for="title">{{ $t('Free1.list.Name') }}</label>
                        <InputText id="title" type="text" :value="search_by_name" :placeholder="$t('Free1.list.SBName')" v-model="search_by_name" />
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                        <label for="title">{{ $t('Free1.list.JobType') }}</label>
                        <InputText id="title" type="text" :value="search_by_job_type" :placeholder="$t('Free1.list.SBJobType')" v-model="search_by_job_type" />
                    </div>
                </div>

                <div class="p-d-flex p-jc-between p-ai-lg-center p-ai-start p-mt-6 p-flex-column p-flex-lg-row">
                    <div class="p-mb-4 p-mb-lg-0"></div>
                    <div class="p-mb-4 p-mb-lg-0">
                        <Button :label="$t('button.search')" icon="pi pi-search" iconPos="left" class="p-button p-component p-button p-button-sm p-mr-2 p-mb-2" @click="SearchFree"></Button>
                        <Button :label="$t('button.reset')" icon="pi pi-replay" iconPos="left" class="p-button p-component p-button p-button-sm p-mr-2 p-mb-2" @click="resetFree"></Button>
                    </div>
                </div>
            </div>
        </div>
        <div class="p-col-12">
            <div class="card">
                <h5>{{ $t('Free1.list.Heading') }}</h5>
                <div class="p-mb-4 p-mb-lg-0 page">
                    <label for="order"
                        >{{ $t('Free1.list.Total') }}: {{ pagination.total_records }}
                        <Dropdown class="p-ml-2" id="order" v-model="pagination.pagination_limit" :options="pagination_limit_options" optionLabel="label" optionValue="value" placeholder="10개씩 보기" />
                    </label>
                </div>
                <br />
                <DataTable :value="results" :paginator="false" class="p-datatable-gridlines" :rows="10" dataKey="id" :rowHover="true" :loading="loading1" :filters="filters1" responsiveLayout="scroll" v-model:selection="selected">
                    <!-- v-model:selection="selected" -->
                    <ConfirmDialog group="dialog" />

                    <template #empty>문의를 찾을 수 없습니다</template>
                    <template #loading>어드민 정보 로딩중..</template>

                    <!-- <column selectionMode="multiple" style="width: 16px; text-align: center" /> -->
                    <Column field="slNO" :header="$t('Free1.list.No')" style="min-width: 4rem">
                        <template #body="{ index }">
                            <span class="p-column-title">#</span>
                            {{ pagination.current_page * pagination.pagination_limit - pagination.pagination_limit + (index + 1) }}
                        </template>
                    </Column>
                    <Column field="Company Name" :header="$t('Free1.list.CompanyName')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Company Name</span>
                            {{ data.company_name === null ? '---' : data.company_name }}
                        </template>
                    </Column>
                    <Column :header="$t('Free1.list.Manager')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Manager Name</span>
                            {{ data.manager_name === null ? '---' : data.manager_name }}
                        </template>
                    </Column>
                    <Column :header="$t('Free1.list.JobType')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Job type</span>
                            {{ data.job_type === null ? '---' : data.job_type }}
                        </template>
                    </Column>
                    <Column :header="$t('Free1.list.status')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Status</span>
                            <!-- <InputSwitch v-model="data.status" trueValue="active" @change="switchValue(data.id, data.status)" /> -->
                            <span v-if="data.status === '0'">대기</span>
                            <span v-else-if="data.status === '1'">승인</span>
                            <span v-else>거절</span>
                        </template>
                    </Column>

                    <Column :header="$t('Admin.list.Action')" style="min-width: 6rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Balance</span>
                            <!-- <p style="display: none">{{ data.mobile }}</p> -->
                            <div style="display: flex">
                                <router-link :to="'/PaidFeatureManagement/Free/ViewFree/' + data.job_id"
                                    ><Button label="info" class="p-button2"><i class="pi pi-eye p-mr-2"></i> </Button>
                                </router-link>
                                <!-- <router-link :to="'/AdminManagement/EditAdmin/' + data.id"
                                    ><Button label="info" class="p-button2"><i class="pi pi-user-edit p-mr-2"></i> </Button>
                                </router-link> -->
                                <!-- <Button icon="pi pi-trash" class="p-button2" @click="confirm2(data.job_id)" /> -->
                            </div>
                        </template>
                    </Column>
                </DataTable>
                <div class="p-paginator p-component p-paginator-bottom">
                    <button @click="paginate(1)" :class="{ 'p-disabled': pagination.current_page === 1 }" class="p-paginator-first p-paginator-element p-link" type="button" :disabled="pagination.current_page === 1">
                        <span class="p-paginator-icon pi pi-angle-double-left"></span>
                        <span class="p-ink"></span>
                    </button>
                    <button @click="paginate(pagination.current_page - 1)" :class="{ 'p-disabled': pagination.current_page === 1 }" class="p-paginator-next p-paginator-element p-link" type="button" :disabled="pagination.current_page === 1">
                        <span class="p-paginator-icon pi pi-angle-left"></span>
                        <span class="p-ink"></span>
                    </button>
                    <span class="p-paginator-pages">
                        <button
                            v-for="(page, index) in get_paginator_page(pagination.total_pages, pagination.current_page)"
                            :key="index"
                            @click="paginate(page)"
                            class="p-paginator-page p-paginator-element p-link"
                            :class="{ 'p-highlight': page === pagination.current_page }"
                            type="button"
                        >
                            {{ page }}<span class="p-ink"></span>
                        </button>
                    </span>
                    <button
                        @click="paginate(pagination.current_page + 1)"
                        :class="{ 'p-disabled': pagination.current_page === pagination.total_pages }"
                        class="p-paginator-next p-paginator-element p-link"
                        type="button"
                        :disabled="pagination.current_page === pagination.total_pages"
                    >
                        <span class="p-paginator-icon pi pi-angle-right"></span>
                        <span class="p-ink"></span>
                    </button>
                    <button
                        @click="paginate(pagination.total_pages)"
                        :class="{ 'p-disabled': pagination.current_page === pagination.total_pages }"
                        :disabled="pagination.current_page === pagination.total_pages"
                        class="p-paginator-last p-paginator-element p-link"
                        type="button"
                    >
                        <span class="p-paginator-icon pi pi-angle-double-right"></span>
                        <span class="p-ink"></span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FreeService from '../../../service/API/FreeService';
import axios from 'axios';
import utils from '@/service/utils';
export default {
    data() {
        return {
            loading1: false,
            products: null,
            expandedRows: [],
            results: [],
            render2: false,

            dropdownItem: null,
            error: {},
            //params for list
            name: '',
            status: '',
            email: '',
            phone_number: '',
            user: {
                menus: [],
            },
            pagination_limit_options: [
                { label: '10개씩 보기', value: 10 },
                { label: '20개씩 보기', value: 20 },
                { label: '50개씩 보기', value: 50 },
                { label: '100개씩 보기', value: 100 },
            ],
            pagination: {
                current_page: 1,
                pagination_limit: 10,
                total_pages: 0,
                total_records: 0,
            },
            search_by_name: '',
            search_by_job_type: '',
            totalrecords: '',
            fileName: '',
            fileExtension: '',
            filesExtension: '',
            files: '',
            filesName: '',
            file: '',
            modal_image: '',
            image: '',
            ad_type_id: '5',
            job_id: '',
            id: '',
            render1: false,
            details: { ad_type: '', created_at: '', description: '', modal_info: '', status: '' },
            formData: new FormData(),
        };
    },
    // customerService: null,
    AdminService: null,
    created() {
        this.freeService = new FreeService();
        // this.search_by_job_type = localStorage.getItem('search_job_type')
        // this.search_by_name = localStorage.getItem('search_name')
        // const params = {
        //     search_by_job_type: this.search_by_job_type,
        //     search_by_name: this.search_by_name,
        // };
        // this.callAPI(params);
    },
    mounted() {
        // this.getFRlist();
        this.getFreeDetails();

        this.storageData = localStorage.getItem('FreeManagement') ? JSON.parse(localStorage.getItem('FreeManagement')) : '';

        if (this.storageData != '') {
            this.FreePagination = this.storageData.current_page;
            this.search_by_job_type = this.storageData.search_by_job_type == undefined ? '' : this.storageData.search_by_job_type;
            this.search_by_name = this.storageData.search_by_name == undefined ? '' : this.storageData.search_by_name;
        }
        if (this.FreePagination == '' || this.FreePagination == null) {
            if (this.search_by_name || this.search_by_job_type) {
                const searchLocalParams = {
                    page: this.pagination.current_page,
                    limit: this.pagination.pagination_limit,
                    search_by_name: this.storageData.search_by_name == undefined ? '' : this.storageData.search_by_name,
                    search_by_job_type: this.storageData.search_by_job_type == undefined ? '' : this.storageData.search_by_job_type,
                };
                this.getFRlist(searchLocalParams);
            } else {
                this.getFRlist({ limit: this.pagination.pagination_limit, page: this.pagination.current_page });
            }
        } else {
            const searchLocalParams = {
                page: this.FreePagination,
                limit: this.pagination.pagination_limit,
                search_by_name: this.storageData.search_by_name == undefined ? '' : this.storageData.search_by_name,
                search_by_job_type: this.storageData.search_by_job_type == undefined ? '' : this.storageData.search_by_job_type,
            };
            this.getFRlist(searchLocalParams);
        }
    },
    watch: {
        'pagination.pagination_limit'(val) {
            this.getFRlist({ limit: val, page: 1 });
        },
    },
    methods: {
        // callAPI(val) {

        // },
        getFreeDetails() {
            this.freeService.FreeDetail('free').then((res) => {
                this.details.status = res[0].status;
                this.details.ad_type = res[0].ad_type;
                this.details.description = res[0].description;
                this.modal_image = res[0].modal_image;
                this.old_file = res[0].modal_image;
                this.details.modal_info = res[0].modal_info;
                console.log(res);
            });
        },
        getFRlist(data) {
            // const FreeParams = {
            //     page: 1,
            //     limit: this.pagination.pagination_limit,
            // };
            this.loading1 = true;
            this.freeService
                .getFreeList(data)
                .then((res) => {
                    this.results = res.data.result;
                    this.totalrecords = res.data.total_records;
                    this.setPagination(res.data.current_page, res.data.total_pages === 0 ? 1 : res.data.total_pages, res.data.total_records);
                    this.loading1 = false;
                    // console.log(res);
                })
                .catch((err) => console.log(err));
            // this.callAPI(FreeParams);
            // this.freeService
            //     .getFreeList(FreeParams)
            //     .then((res) => {
            //         this.results = res.data.result;
            //         this.totalrecords = res.data.total_records;
            //         this.setPagination(res.data.current_page, res.data.total_pages === 0 ? 1 : res.data.total_pages, res.data.total_records);
            //         this.loading1 = false;
            //         console.log(res);
            //     })
            //     .catch((err) => console.log(err));
        },
        setPagination(current_page, total_pages, total_records) {
            this.pagination.current_page = current_page;
            this.pagination.total_pages = total_pages;
            this.pagination.total_records = total_records;
        },
        get_paginator_page(total, active) {
            return utils.paginate(total, active);
        },

        paginate(page) {
            this.loading = true;
            localStorage.setItem(
                'FreeManagement',
                JSON.stringify({
                    current_page: page,
                    // limit: this.pagination.pagination_limit,
                    search_by_job_type: this.search_by_job_type,
                    search_by_name: this.search_by_name,
                })
            );
            this.freeService
                .getFreeList({
                    page: page,
                    limit: this.pagination.pagination_limit,
                    search_by_job_type: this.search_by_job_type,
                    search_by_name: this.search_by_name,
                })
                .then((res) => {
                    this.results = res.data.result;
                    this.pagination.current_page = page;
                    this.loading = false;
                    console.log(res.data);
                })
                .catch((err) => console.log(err));
        },
        switchValue(ids, switchstatus) {
            console.log(ids, switchstatus);
            var self = this;
            axios({ method: 'post', url: '/api/v1/admin/banner/status-update', data: { banner_id: ids, status: switchstatus === false ? 'deleted' : 'active' } }).then(function (response) {
                // this.$router.push({ name: 'Banner Management' });
                self.$toast.add({ severity: 'info', summary: '확인.', detail: 'Banner Status Upated Successfully.', life: 3000 });
                console.log(response);
            });
        },
        resetFree() {
            // localStorage.setItem('search_name', '');
            // localStorage.setItem('search_job_type', '');
            this.search_by_job_type = '';
            this.search_by_name = '';
            this.pagination.pagination_limit = '';
            localStorage.setItem('FreeManagement', '');

            this.getFRlist(); // for refresh the table data
            window.location.reload();
        },
        onFileChange(e) {
            // this.formData.delete('file');
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            this.file = files[0];
            var allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
            if (!allowedExtensions.exec(this.file.name)) {
                this.render1 = true;
                return false;
            } else {
                this.render1 = false;
                if (this.file.size > 26214400) {
                    // alert('파일이 너무 큽니다  ');
                    this.render2 = true;
                } else {
                    this.render2 = false;
                    this.fileName = this.file.name;
                    this.formData.append('image', files[0]);
                }
            }
            this.fileExtension = this.fileName.replace(/^.*\./, '');
            console.log(this.fileName);
        },

        confirm(event) {
            // confirm($event)

            // alert(this.mydata.notice_id)
            this.$confirm.require({
                target: event.currentTarget,
                group: 'popup',
                message: '계속 진행하시겠습니까?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: '확인',
                rejectLabel: ' 취소',
                accept: () => {
                    // let vcheckData = {
                    //     // title: this.title,
                    //     // status: this.status ? 'active' : 'inactive',
                    //     file: this.image == '' ? '' : 'something',
                    // };
                    // const { isInvalid, error } = validateCreateEmergency(vcheckData);
                    // if (isInvalid) {
                    //     this.error = error;
                    //     console.log(error);
                    // } else {
                    this.formData.append('ad_type_id', this.ad_type_id);
                    this.formData.append('description', this.details.description);
                    this.formData.append('modal_info', this.details.modal_info);
                    // this.formData.append('status', this.details.status);
                    this.formData.append('status', this.details.status == '' ? 'inactive' : 'active');
                    // this.formData.append('type', this.dropdownValueType?.name === undefined ? this.type : this.dropdownValueType?.name);
                    console.log(this.formData);
                    return axios.post('/api/v1/admin/ad-type/info/edit', this.formData).then((res) => {
                        // this.emergencyService.UpdateEmergency({ad_type_id:this.ad_type_id,description:this.details.description,modal_info:this.details.modal_info,status:this.details.status}).then((res) => {
                        console.warn(res);
                        console.log(this.formData);
                        this.getFreeDetails();
                        this.$toast.add({ severity: 'success', summary: '업데이트 완료', detail: '라인(무료) 정보가 저장되었습니다.', life: 3000 });

                        // this.$router.push({ name: 'Free' });
                        // setTimeout(() => {
                        //     window.location.reload();
                        //     this.$toast.add({ severity: 'success', summary: '업데이트 완료', detail: '라인(무료) 정보가 저장되었습니다.', life: 3000 });
                        // }, 500);
                    });
                    // }
                },
                // reject: () => {
                //     this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
                // },
            });
        },
        confirm2(job_id) {
            var self = this;
            this.$confirm.require({
                group: 'dialog',
                header: '확인',
                message: '삭제하시겠습니까?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: '확인',
                rejectLabel: ' 취소',
                accept: () => {
                    axios({ method: 'post', url: `/api/v1/admin/job-post/delete/`, data: { job_id: job_id.toString() } }).then(function () {});
                    this.getFRlist();
                    self.$toast.add({ severity: 'info', summary: '삭제', detail: '성공적으로 삭제되었습니다.', life: 3000 });
                },
                reject: () => {
                    this.$toast.add({ severity: 'error', summary: '오류가 발생했습니다', detail: '취소되었습니다', life: 3000 });
                },
            });
        },
        SearchFree() {
            if (this.search_by_job_type == '' && this.search_by_name == '') {
                // console.log(this.productCategoryStatus);
                this.$toast.add({ severity: 'error', summary: '에러 메시지', detail: '1개 이상의 검색 값을 입력하세요.', life: 3000 });
            } else {
                localStorage.setItem(
                    'FreeManagement',
                    JSON.stringify({
                        current_page: 1,
                        // limit: this.pagination.pagination_limit,
                        search_by_job_type: this.search_by_job_type,
                        search_by_name: this.search_by_name,
                    })
                );
                // localStorage.setItem('search_job_type', this.search_by_job_type);
                // localStorage.setItem('search_name', this.search_by_name);
                let searchParams = {
                    limit: this.pagination.pagination_limit,
                    page: 1,
                    search_by_job_type: this.search_by_job_type,
                    search_by_name: this.search_by_name,
                };
                this.loading = true;
                this.freeService
                    .getFreeList(searchParams)
                    .then((res) => {
                        this.results = res.data.result;
                        this.totalrecords = res.data.total_records;
                        this.setPagination(res.data.current_page, res.data.total_pages === 0 ? 1 : res.data.total_pages, res.data.total_records);
                        this.loading1 = false;
                        console.log(res);
                    })
                    .catch(() => {
                        this.users = [];
                        this.loading1 = false;
                    });
                // this.callAPI(searchParams);
                this.loading = false;
            }
        },

        exceldownload() {
            this.productCategoryService.getExcel(this.first_category, this.second_category, this.third_category, this.productCategoryStatus?.code).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Productcategorylist.xlsx'); //or any other extension
                document.body.appendChild(link);
                link.click();
            });
        },
        today() {
            const utc = new Date().toJSON().slice(0, 10).replace(/-/g, '.');
            this.start_date = utc;
            this.end_date = utc;
            this.getlist();
            console.log(this.start_date);
        },
        lastweek() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 7);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
            console.log(this.start_date);
        },
        lastmonth() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 31);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
            console.log(this.start_date);
        },
        lastsixmonth() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 182);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
            console.log(this.start_date);
        },
        getParams(NotificationType) {
            localStorage.setItem('NotificationType', NotificationType);
            console.log(NotificationType);
        },
        open() {
            this.display = true;
        },
        close() {
            this.display = false;
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },

        onRowExpand(event) {
            this.$toast.add({ severity: 'info', summary: 'Product Expanded', detail: event.data.name, life: 3000 });
        },
        onRowCollapse(event) {
            this.$toast.add({ severity: 'success', summary: 'Product Collapsed', detail: event.data.name, life: 3000 });
        },
        expandAll() {
            this.expandedRows = this.products.filter((p) => p.id);
            this.$toast.add({ severity: 'success', summary: 'All Rows Expanded', life: 3000 });
        },
        collapseAll() {
            this.expandedRows = null;
            this.$toast.add({ severity: 'success', summary: 'All Rows Collapsed', life: 3000 });
        },
        formatCurrency(value) {
            return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        },
        formatDate(value) {
            const date = new Date(value);
            var dd = date.getDate();
            var mm = date.getMonth() + 1;
            var yyyy = date.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            return (value = yyyy + '.' + mm + '.' + dd);
        },
        calculateCustomerTotal(name) {
            let total = 0;
            if (this.customer3) {
                for (let customer of this.customer3) {
                    if (customer.representative.name === name) {
                        total++;
                    }
                }
            }

            return total;
        },
    },
};
</script>

<style lang="scss" scoped>
.p-datatable-tbody {
    .p-button {
        white-space: nowrap;
    }
}

.p-fluid {
    .p-button {
        width: auto;
    }
}

.p-col-12.p-mb-2.p-lg-6.p-mb-lg-0.p-field.d-flex {
    display: inline-flex;
}

label#switch {
    margin-right: 8px;
}

.img-info {
    font-size: 11px;
    font-weight: 400;
    color: rgb(48, 48, 48);
}

.product-image {
    padding-top: 5px;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 5px;
    width: 150px !important;
    height: 100px;
    float: left;
}

.custom-select {
    position: relative;
    border: 1px solid #cecece;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 15px;
}

.select-file {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0%;
    z-index: 5;
    opacity: 0;
}

.SelectBtn {
    max-width: 100px;
}

.custom-select span {
    max-width: 140px;
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.custom-select-invalid {
    position: relative;
    border: 1px solid red;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 15px;
}

textarea#desc1 {
    height: 18vh;
}

.p-button {
    background: white;
    // border: 1px solid #0A0A0A;
    color: #0a0a0a;
}

button.p-button.p-component.SelectBtn.n-wrap {
    background: blue;
    color: white;
}
</style>
